import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { sortingOptionsSelector } from '../../../../../../redux/product-listing/product-listing.selectors';
import { ProductsSortingOptionsComponent } from './products-sorting-options';
const mapStateToProps = createStructuredSelector({
  sortingOptions: sortingOptionsSelector
});
export const ProductsSortingOptions = connect(mapStateToProps)(ProductsSortingOptionsComponent);